module.exports = __webpack_public_path__ + "static/all-the-data-e558e361d2f085fd4417d44463675ad3.svg";